import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    height={`${size}`}
    width={`${size}`}
    {...props}
  >
    <g transform="translate(4 4)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <circle cx="6" cy="6" r="6" />
      <path strokeLinecap="round" d="M10.5 10.5 15 15" />
    </g>
  </svg>
);
